import { AVERAGE_AGE_GROUP_YEARS } from './AVERAGE_AGE_GROUP_YEARS'
import { MAX_AGE } from './MAX_AGE'

export const AVERAGE_AGE_BIRTH_DATE_CUTOFF =
	Math.floor((new Date().getFullYear() - MAX_AGE) / AVERAGE_AGE_GROUP_YEARS) *
		AVERAGE_AGE_GROUP_YEARS +
	''
